import React, { useEffect } from 'react';
import { Hammer, Palette, Scissors, Ruler, PenTool, Layout, Users, Sparkles, Layers, Shirt, Package, Paintbrush, Image, Box, Type, Circle, Shapes } from 'lucide-react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { LOGIN_ROUTE } from '../../../routes/web/rootRoutes';
import authManager from '../../../utils/authManager';


function DepartmentsShowcase() {
    useEffect(() => {
        AOS.init({
            duration: 800,
            once: true,
            offset: 50,
            easing: 'ease-in-out'
        });

        return () => {
            AOS.refresh();
        };
    }, []);




    const departments = [
         {
            id: 1,
            name: 'PRODUCTION DESIGNER',
            icon: <Sparkles className="w-6 h-6 md:w-8 md:h-8" />,
            gradient: 'from-indigo-500 to-purple-500',
            description: 'Overall visual concept',
        },
         {
            id: 2,
            name: 'ART DIRECTOR',
            icon: <Palette className="w-6 h-6 md:w-8 md:h-8" />,
            gradient: 'from-blue-500 to-cyan-500',
            description: 'Leading creative vision',
        },
        {
            id: 3,
            name: 'ASST. ART DIRECTOR',
            icon: <Layout className="w-6 h-6 md:w-8 md:h-8" />,
            gradient: 'from-purple-500 to-pink-500',
            description: 'Creative Assistant',
        },
         {
            id: 4,
            name: 'APPT. ASST. ART DIRECTOR',
            icon: <Layers className="w-6 h-6 md:w-8 md:h-8" />,
            gradient: 'from-green-500 to-emerald-500',
            description: 'Creative Department Trainee',
        },
       
         
        {
            id: 5,
            name: 'COSTUME DESIGNER',
            icon: <Scissors className="w-6 h-6 md:w-8 md:h-8" />,
            gradient: 'from-pink-500 to-rose-500',
            description: 'Character wardrobe expert',
        },
      
          {
            id: 6,
            name: 'ASST. COSTUME DESIGNER',
            icon: <Scissors className="w-6 h-6 md:w-8 md:h-8" />,
            gradient: 'from-red-500 to-orange-500',
            description: 'Apprentice Assistant Costume Designer',
        },
        {
            id: 7,
            name: 'APPT. ASST COSTUME DESIGNER',
            icon: <Shirt className="w-6 h-6 md:w-8 md:h-8" />,
            gradient: 'from-yellow-500 to-amber-500',
            description: 'Appointed assistant costume designer',
        },
      
       
        {
            id: 8,
            name: 'SET DESIGNER',
            icon: <Ruler className="w-6 h-6 md:w-8 md:h-8" />,
            gradient: 'from-lime-500 to-green-500',
            description: 'Creating immersive sets',
        },
         {
            id: 9,
            name: 'SET ASSISTANT',
            icon: <Users className="w-6 h-6 md:w-8 md:h-8" />,
            gradient: 'from-amber-500 to-orange-500',
            description: 'Set design support',
        },
        {
            id: 10,
            name: 'PROPMAN',
            icon: <Package className="w-6 h-6 md:w-8 md:h-8" />,
            gradient: 'from-teal-500 to-cyan-500',
            description: 'Property management',
        },
        
        {
            id: 11,
            name: 'MURAL ARTIST',
            icon: <Paintbrush className="w-6 h-6 md:w-8 md:h-8" />,
            gradient: 'from-orange-500 to-red-500',
            description: 'Wall art specialist',
        },
        {
            id: 12,
            name: 'BACKGROUND ARTIST',
            icon: <Image className="w-6 h-6 md:w-8 md:h-8" />,
            gradient: 'from-violet-500 to-purple-500',
            description: 'Background scenery creation',
        },
        {
            id: 13,
            name: 'THERMACOL ARTIST',
            icon: <Box className="w-6 h-6 md:w-8 md:h-8" />,
            gradient: 'from-cyan-500 to-blue-500',
            description: 'Thermocol prop creation',
        },
        
       
        {
            id: 14,
            name: 'LETTERING ARTIST',
            icon: <Type className="w-6 h-6 md:w-8 md:h-8" />,
            gradient: 'from-rose-500 to-pink-500',
            description: 'Typography & signage',
        },
        {
            id: 15,
            name: 'DESIGNER STYLIST',
            icon: <PenTool className="w-6 h-6 md:w-8 md:h-8" />,
            gradient: 'from-fuchsia-500 to-purple-500',
            description: 'Fashion & aesthetic styling',
        },
        {
            id: 16,
            name: 'RUBBER ARTIST',
            icon: <Circle className="w-6 h-6 md:w-8 md:h-8" />,
            gradient: 'from-sky-500 to-blue-500',
            description: 'Rubber prop creation',
        },
        {
            id: 17,
            name: 'MOULDER DESIGNER',
            icon: <Shapes className="w-6 h-6 md:w-8 md:h-8" />,
            gradient: 'from-emerald-500 to-teal-500',
            description: 'Sculpting & molding expert',
        },
        {
            id: 18,
            name: 'MISTRY',
            icon: <Hammer className="w-6 h-6 md:w-8 md:h-8" />,
            gradient: 'from-red-500 to-pink-500',
            description: 'Master craftsman',
        }
    ];

    const allDepartments = useSelector((state) => state?.globalState?.siteSetting?.category);


      const user = authManager.getUserProfile();


    return (
        <section className="relative py-12 overflow-hidden md:py-16 lg:py-20 bg-gradient-to-b from-gray-50 via-white to-gray-50">
            <div className="container relative z-10 px-2 mx-auto max-w-7xl md:px-4">
                {/* Section Header */}
                <div className="mb-10 text-center md:mb-16" data-aos="fade-up">
                    <span className="inline-block px-3 py-1.5 md:px-4 md:py-2 bg-gradient-to-r from-red-500 to-yellow-500 text-white text-xs md:text-sm font-semibold rounded-full mb-3 md:mb-4">
                        Our Expertise
                    </span>
                    <h2 className="px-4 mb-2 text-2xl font-bold text-transparent md:text-4xl lg:text-5xl xl:text-6xl bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text md:mb-4">
                        Professional Departments
                    </h2>
                    <p className="max-w-2xl px-4 mx-auto text-sm text-gray-600 md:text-base lg:text-lg">
                        Explore our diverse range of specialized departments dedicated to excellence in art direction and costume design
                    </p>
                </div>

                {/* Featured Department Cards */}
                <div className="grid grid-cols-2 gap-3 mb-10 md:grid-cols-3 lg:grid-cols-4 md:gap-4 lg:gap-6 md:mb-16">
                    {departments.map((dept, index) => (
                        <div
                            key={dept.id}
                            data-aos="fade-up"
                            data-aos-delay={index * 50}
                            className="relative p-3 overflow-hidden transition-all duration-500 bg-white shadow-md group rounded-xl md:rounded-2xl md:p-5 lg:p-6 hover:shadow-xl hover:-translate-y-1 md:hover:-translate-y-2"
                        >
                            <div className={`absolute inset-0 bg-gradient-to-br ${dept.gradient} opacity-0 group-hover:opacity-10 transition-opacity duration-500`}></div>

                            <div className={`relative w-10 h-10 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-lg md:rounded-xl bg-gradient-to-br ${dept.gradient} flex items-center justify-center text-white mb-2 md:mb-3 lg:mb-4 group-hover:scale-110 transition-transform duration-500 shadow-md md:shadow-lg`}>
                                {dept.icon}
                            </div>

                            <h3 className="relative mb-1 text-xs font-bold leading-tight text-gray-800 transition-all duration-300 md:text-sm lg:text-base xl:text-lg md:mb-2 group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:bg-clip-text group-hover:from-red-500 group-hover:to-yellow-500">
                                {dept.name}
                            </h3>
                            <p className="relative text-[10px] md:text-xs lg:text-sm text-gray-600 leading-snug">
                                {dept.description}
                            </p>


                        </div>
                    ))}
                </div>

                {/* All Departments Grid */}
                {/* <div data-aos="fade-up" data-aos-delay="200" className="p-5 bg-white shadow-lg rounded-2xl md:rounded-3xl md:shadow-xl md:p-8 lg:p-12">
                    <div className="mb-6 text-center md:mb-10">
                        <h3 className="mb-2 text-xl font-bold text-gray-800 md:text-2xl lg:text-3xl md:mb-3">
                            Complete Department List
                        </h3>
                        <p className="px-4 text-xs text-gray-600 md:text-sm lg:text-base">
                            All specialized roles and positions available in our association
                        </p>
                    </div>

                    <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-3 md:gap-3 lg:gap-4">
                        {allDepartments.map((dept, index) => (
                            <div
                                key={index}
                                data-aos="zoom-in"
                                data-aos-delay={index * 15}
                                className="relative p-3 overflow-hidden transition-all duration-300 border-2 border-gray-100 rounded-lg cursor-pointer group bg-gradient-to-br from-gray-50 to-white md:rounded-xl md:p-4 hover:border-transparent hover:shadow-md md:hover:shadow-lg"
                            >
                                <div className="absolute inset-0 transition-opacity duration-500 opacity-0 bg-gradient-to-r from-red-500 via-yellow-500 to-red-500 group-hover:opacity-100 -z-10"></div>
                                <div className="absolute inset-[2px] bg-white rounded-lg md:rounded-xl group-hover:bg-gradient-to-br group-hover:from-gray-50 group-hover:to-white"></div>

                                <div className="relative flex items-center gap-2 md:gap-3">
                                    <div className="w-1.5 h-1.5 md:w-2 md:h-2 rounded-full bg-gradient-to-r from-red-500 to-yellow-500 group-hover:scale-150 transition-transform duration-300 flex-shrink-0"></div>
                                    <span className="text-xs font-semibold leading-tight text-gray-700 transition-colors md:text-sm group-hover:text-gray-900">
                                        {dept}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>  */}

                {/* Call to Action */}
                {/* {
    user ? ' ' :
                <div className="mt-8 text-center md:mt-12 lg:mt-16" data-aos="fade-up" data-aos-delay="300">
                    <a
                        href="#"
                        className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-white transition-all duration-300 transform rounded-full shadow-lg md:px-8 md:py-4 bg-gradient-to-r from-red-500 to-yellow-500 md:text-base md:shadow-xl hover:shadow-2xl hover:scale-105"
                    >
                        <span>Join Our Association</span>
                        <svg className="w-4 h-4 md:w-5 md:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                    </a>
                </div>
} */}
            </div>
        </section>
    );
}

export default DepartmentsShowcase;